import defaultTo from 'ramda/es/defaultTo';
import path from 'ramda/es/path';

export const getUser = (appState) => appState.auth.user;

export const getUID = (state) => defaultTo(null, path(['auth', 'user', 'uid'], state));

export const getSearchTokenFromState = (state) => state.auth.searchToken;
